<template>
  <div class="qrcode">
    <div class="layout bgwhite">
      <div class="top">
        <!-- qrcode -->
        <canvas id="qrcode" class="qrcode"></canvas>
        <!-- <img class="qrcode" src="../assets/images/footer/erweima.jpg" alt /> -->
      </div>
      <div class="bottom">
        <div class="scaner">
          <img src="../assets/images/public/scaner@2x.png" alt />
        </div>
        <div class="expain">
          <p>扫码二维码</p>
          <p>下载APP</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
export default {
  name: "qrcode",
  mounted() {
    this.qrcodeInit();
    // this.$router.push("/downloadApp");
  },
  methods: {
    qrcodeInit() {
      // this.qrlink = `http://${location.host}/homePage/downloadApp`;
      this.qrlink = 'http://downapp.tuxiaozhu.com';
      // this.qrlink = "http://192.168.0.138:8050/homepage/downloadApp";
      // console.log(this.qrlink);
      let canvas = document.getElementById("qrcode");
      QRCode.toCanvas(
        canvas,
        this.qrlink,
        { width: 120, height: 120 },
        error => {
          if (error) console.error(error);
        }
      );
      let qr = QRCode;
      console.log(qr);
    }
  }
};
</script>


<style lang="scss" scoped>
.qrcode {
  position: fixed;
  top: 615px;
  right: 75px;
  box-shadow: 0px 2px 4px 0px rgba(219, 218, 232, 1);
  border-radius: 9px;
  z-index: 99999;
  .layout {
    width: 168px;
    height: 206px;
    .top {
      width: 100%;
      height: 152px;
      .qrcode {
        width: 120px;
        height: 120px;
        margin-right: 24px;
        margin-top: 17px;
      }
    }
    .bottom {
      text-align: center;
      height: 38px;
      display: flex;
      justify-content: center;
      align-items: center;
      .scaner {
        float: left;
        img {
          width: 46px;
          height: 36px;
        }
      }
      .expain {
        float: left;
        p {
          font-size: 12px;
          color: #212240;
          &:last-child {
            font-size: 15px;
            color: #695fff;
          }
        }
      }
    }
  }
}
</style>
